import { MicroSiteTemplate } from "./template";

export enum ApiStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  FAILED = "failed"
}

export type CreateMicroSiteResponse = {
  pollId: string;
  status: ApiStatus;
  errors: string[];
  companyName?: string;
  companyDetails: CompanyDetails;
};

export type PollCreateMicroSiteResponse = {
  companyName?: string;
  companyDetails: CompanyDetails;
  status: ApiStatus;
  progressPercentage: number;
  pollId: string;
  errors: string[];
  template: MicroSiteTemplate;
  suggestedDomains: string[];
};

export type CompanyDetails = {
  companyName: string;
  companyDomain: string;
  businessUnits: string[];
  userRoles: string[];
};

// export type GetMicroSiteTemplateResponse = {
//   template: MicroSiteTemplate;
//   status: ApiStatus;
//   errors: string[];
// };

export type APIResponse<T> = {
  data: T;
  error: boolean;
  message: string;
};
